module.exports = __webpack_public_path__ + "static/media/Dysrhythmia_Question8.ded102b5.jpg";